import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import { OrderListRowAction } from 'commons/enums';
import { PickingTask } from 'commons/types';
import {
  prioritizeOrderPick,
  retryUpdateFailedOrder,
  syncAwbAction,
  unPrioritizeOrderPick,
} from 'redux-stores/actions';

export const RowMenuItemConfig = [
  {
    name: 'Prioritize',
    key: OrderListRowAction.PRIORITIZE_TASK,
    onClick: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      poNumber: string,
      location?: number,
    ): void => {
      dispatch(prioritizeOrderPick({ poNumber, location }));
    },
    disabled: (selected: PickingTask[]): boolean => {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].picker === null) return false;
      }
      return true;
    },
  },
  {
    name: 'Unprioritize',
    key: OrderListRowAction.UNPRIORITIZE_TASK,
    onClick: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      poNumber: string,
      location?: number,
    ): void => {
      dispatch(unPrioritizeOrderPick({ poNumber, location }));
    },
    disabled: (selected: PickingTask[]): boolean => {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].picker === null) return false;
      }
      return true;
    },
  },
  {
    name: 'Retry',
    key: OrderListRowAction.RETRY,
    onClick: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      poNumber: string,
      location?: number,
    ): void => {
      dispatch(retryUpdateFailedOrder({ poNumber, location }));
    },
    disabled: (selected: PickingTask[]): boolean => {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].status === 'update-failed') return false;
      }
      return true;
    },
  },
  {
    name: 'Sync AWB Info',
    key: OrderListRowAction.SYNC_AWB,
    onClick: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      poNumber: string,
    ): void => {
      dispatch(syncAwbAction({ poNumbers: [poNumber] }));
    },
    disabled: (): boolean => false,
  },
];
